// Track an event
export const trackMetaPixelEvent = (eventName, eventParams) => {
  if (window.fbq) {
    window.fbq('track', eventName, eventParams);
  } else {
    console.error('Meta Pixel (fbq) is not initialized');
  }
};